import { render } from "./FakeSelect.vue?vue&type=template&id=806d8654"
import script from "./FakeSelect.vue?vue&type=script&lang=js"
export * from "./FakeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__